import "./App.css";
import Main from "./pages/Main";
import { Routes, Route } from "react-router-dom";
import VerticalTimeline from "./pages/VerticalTimeline";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import SocialLinks from "./components/SocialLinks";

function App() {
  return (
    <div className="App">
      <Navbar />
      <SocialLinks />
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/timeline" element={<VerticalTimeline />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
